import { BaseService } from './base';
import { ApiRequest } from '../lib/request';
import { CustomField } from '../models/customField';

export class CustomFieldService extends BaseService<CustomField> {
  override model = CustomField;
  override modelName = 'customField';
  override modelLabel = 'Custom Field';

  async deleteWithOptions(
    customField: CustomField,
    showPastData: boolean = false,
  ): Promise<boolean> {
    const request = new ApiRequest({
      method: 'DELETE',
      url: `${this.modelBaseUrl}/${customField.objectID()}`,
      query: {
        showPastData: showPastData ? '1' : '0',
      },
    });

    const response = await this.request(request);
    return response.success;
  }
}
